import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import TRANSLATIONS from '../../../translations/translations@default.json';

const ProductDataSheet = ({ ProductDatasheetPdfUrl, is2020Label }) => {
	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	if (!ProductDatasheetPdfUrl) {
		return null;
	}
	return (
		<a
			href={ProductDatasheetPdfUrl}
			alt="product data sheet"
			target="_blank"
			rel="noopener noreferrer"
			data-tag-name="product-data-sheet-clicked"
			className={classNames(
				'font-bold block text-body-xs text-cta-action z-10 relative',
				{
					'ml-1': is2020Label && CustomCategoriesEnabled,
					'ml-5': !is2020Label && CustomCategoriesEnabled,
					'z-10': CustomCategoriesEnabled,
					'ml-0': !CustomCategoriesEnabled,
				}
			)}>
			{TRANSLATIONS.productList.productCard.energyLabel.productDataSheet}
		</a>
	);
};

export default ProductDataSheet;
